import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Accordion } from '@sainsburys-tech/bolt'
import { ThemeContext } from 'styled-components'
import { createGolNonContentDataAttributes } from '../../../helpers/tracking'
import * as Styled from './M054.styles'

/**
 * M054 is an accordion component with rich text field body copy.
 */
const dataTest = 'm054'
const M054 = ({ heading, bodyCopy, id, gridHeading }) => {
  const theme = useContext(ThemeContext)
  const isSainsburys = theme?.channel === 'sainsburys'

  const bodyCopyMarkup = () => ({ __html: bodyCopy })

  const addGolTracking = () => {
    const accordionComponent = document.querySelector(`#${dataTest}-accordion-component-${id}`)
    const dataAttributes = createGolNonContentDataAttributes(
      'link',
      'expand',
      'accordion',
      `M054-${gridHeading.toLowerCase() || 'NA'}-${heading.toLowerCase()}`,
      'interaction'
    )
    Object.keys(dataAttributes).forEach((attribute) =>
      accordionComponent.setAttribute(attribute, dataAttributes[attribute])
    )
  }

  const handleClick = () => {
    if (isSainsburys) {
      addGolTracking()
    }
  }

  return (
    <Accordion.Item
      id={`${dataTest}-accordion-component-${id}`}
      as={isSainsburys ? undefined : 'h3'} // this is to mitigate the large font sizes on Luna, should be reverted after they've addressed
      hasBorderBottom
      title={heading}
      data-test={`${dataTest}-accordion-${id}`}
      onClick={handleClick}
      style={isSainsburys ? { backgroundColor: 'white', marginBottom: '1rem' } : {}}
    >
      <Styled.RowWrapper gutterValue={0} gutterSize='16px'>
        <Styled.ColumnWrapper
          xs={12}
          data-test={`${dataTest}-bodyCopy`}
          dangerouslySetInnerHTML={bodyCopyMarkup()}
          gutterValue={1}
        />
      </Styled.RowWrapper>
    </Accordion.Item>
  )
}

M054.propTypes = {
  /** id attribute for data-test */
  id: PropTypes.string,
  /** Required heading to be displayed */
  heading: PropTypes.string.isRequired,
  /** Required bodyCopy that is rendered as HTML in the Accordion drop down */
  bodyCopy: PropTypes.string.isRequired,
  /** Grid heading for tracking purposes */
  gridHeading: PropTypes.string
}

export default M054
